import { axiosInstance } from "@/config/axios-wrapper";
import { V2Response } from "@/types/api";

type EmployerSignUpPayload = {
  payment_method_id?: string;
  [key: string]: unknown;
};

export const userLogin = async (data) => {
  const response = await axiosInstance.post<V2Response<any>>("/users/login", data);
  return response.data.result;
};

type GoogleLoginPayload = {
  id_token: string;
  timezone?: string;
};

export const googleLogin = async (data: GoogleLoginPayload) => {
  const response = await axiosInstance.post<V2Response<any>>("/users/login/google", data);
  return response.data.result;
};

export const employerSignUp = async (data: EmployerSignUpPayload) => {
  const response = await axiosInstance.post<V2Response<any>>("/organizations", data);
  return response.data.result;
};

export const forgotPass = async (data) => {
  const response = await axiosInstance.post<V2Response<any>>("/users/forgot-password", data);
  return response.data.result;
};

export const resendEmail = async (data) => {
  const response = await axiosInstance.post<V2Response<any>>("/users/resend-verification", data);
  return response.data.result;
};

export const refreshTokenApi = async (data: { refresh_token: string }) => {
  const response = await axiosInstance.post<V2Response<{ access_token: string }>>(
    "/auth/refreshToken",
    data,
  );
  return response.data.result;
};

export const jobSeekerRegister = async (data) => {
  const response = await axiosInstance.post<V2Response<any>>("/jobseekers/register", data);
  return response.data.result;
};

export const socialLogin = async (data: {
  id_token: string;
  provider: "google";
  role: "job_seeker" | "employer";
  context: "login" | "signup";
  timezone: string;
}) => {
  const response = await axiosInstance.post<V2Response<any>>("/auth/social-login", data);
  return response.data.result;
};
